const mediaFrame2dImageSrc = require("../assets/images/media_frame_2d_placeholder_new.png?inline");
const mediaFrame2dImageSquareSrc = require("../assets/images/media_frame_2d_placeholder_new.png?inline");

const mediaFrame3dImageLandscapeSrc = require("../assets/images/media_frame_2d_placeholder_new.png?inline");
const mediaFrame3dImageSquareSrc = require("../assets/images/media_frame_2d_placeholder_new.png?inline");
const mediaFrame3dImagePortraitSrc = require("../assets/images/media_frame_2d_placeholder_new.png?inline");

const mediaFrame2dImage = new Image();
const mediaFrame2dImageSquare = new Image();

const mediaFrame3dImageLandscape = new Image();
const mediaFrame3dImageSquare = new Image();
const mediaFrame3dImagePortrait = new Image();

mediaFrame2dImage.crossOrigin = "anonymous";
mediaFrame2dImageSquare.crossOrigin = "anonymous";

mediaFrame3dImageLandscape.crossOrigin = "anonymous";
mediaFrame3dImageSquare.crossOrigin = "anonymous";
mediaFrame3dImagePortrait.crossOrigin = "anonymous";

mediaFrame2dImage.src = mediaFrame2dImageSrc;
mediaFrame2dImageSquare.src = mediaFrame2dImageSquareSrc;

mediaFrame3dImageLandscape.src = mediaFrame3dImageLandscapeSrc;
mediaFrame3dImageSquare.src = mediaFrame3dImageSquareSrc;
mediaFrame3dImagePortrait.src = mediaFrame3dImagePortraitSrc;

export const mediaFrame2dTexture = new THREE.Texture(mediaFrame2dImage);
export const mediaFrame2dTextureSquare = new THREE.Texture(mediaFrame2dImageSquare);

export const mediaFrame3dTextureLandscape = new THREE.Texture(mediaFrame3dImageLandscape);
export const mediaFrame3dTextureSquare = new THREE.Texture(mediaFrame3dImageSquare);

export const mediaFrame3dTexturePortrait = new THREE.Texture(mediaFrame3dImagePortrait);

mediaFrame2dImage.onload = () => {
  mediaFrame2dTexture.needsUpdate = true;
};

mediaFrame2dImageSquare.onload = () => {
  mediaFrame2dTextureSquare.needsUpdate = true;
};

mediaFrame3dImageLandscape.onload = () => {
  mediaFrame3dTextureLandscape.needsUpdate = true;
};

mediaFrame3dImageSquare.onload = () => {
  mediaFrame3dTextureSquare.needsUpdate = true;
};

mediaFrame3dImagePortrait.onload = () => {
  mediaFrame3dTexturePortrait.needsUpdate = true;
};
